import React from 'react';
import useIntersectionObserver from '../../hooks/useIntersectionObserver';

const ITEMS = [
  {
    title: 'Auto detailing w Gdańsku',
    text: 'Detaling Gdańsk to nasza specjalność: polerowanie, usuwanie rys, glinkowanie lakieru, woskowanie i powłoki hydrofobowe. Dbamy o każdy detal, żeby auto wyglądało jak nowe.',
  },
  {
    title: 'Ręczna myjnia samochodowa',
    text: 'Mycie auta w Gdańsku wykonujemy ręcznie, bezpiecznie dla lakieru. Nasza myjnia samochodowa oferuje mycie karoserii, felg, szyb oraz suszenie i konserwację plastików.',
  },
  {
    title: 'Pranie i czyszczenie tapicerki samochodowej',
    text: 'Pranie tapicerki samochodowej usuwa plamy, zapachy i sierść. Czyszczenie tapicerki foteli i kanapy przywraca wnętrzu świeżość.',
  },
  {
    title: 'Naprawa tapicerki samochodowej',
    text: 'Naprawa tapicerki samochodowej w Gdańsku: usuwamy drobne uszkodzenia i przywracamy wnętrzu pierwotny wygląd.',
  },
  {
    title: 'Renowacja skór samochodowych',
    text: 'Renowacja skór samochodowych w Gdańsku obejmuje czyszczenie, konserwację i odświeżenie skórzanych foteli, kierownic i elementów wnętrza.',
  },
  {
    title: 'Czyszczenie wnętrza i kompleksowe czyszczenie samochodu',
    text: 'Czyszczenie wnętrza samochodu w Gdańsku to odkurzanie, ozonowanie i dezynfekcja. Wykonujemy też kompleksowe czyszczenie samochodu z zewnątrz i od środka.',
  },
];

const AboutServices = () => {
  const [ref, isVisible] = useIntersectionObserver();

  return (
    <section className="py-20">
      <div className="container mx-auto px-4">
        <div
          ref={ref}
          className={`text-center max-w-3xl mx-auto mb-12 transform transition-all duration-700 ease-out
            ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-8 opacity-0'}`}
        >
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            Myjnia Gdańsk: co robimy w Auto Kosmetyce
          </h2>
          <p className="text-gray-300">
            Szukasz myjni w Gdańsku? Zajmujemy się samochodami przy ul. Ignacego Matuszewskiego 11A.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
          {ITEMS.map((item) => (
            <div key={item.title} className="bg-black/30 backdrop-blur-sm p-6 rounded-2xl border border-white/10">
              <h3 className="text-lg font-semibold text-white mb-2">{item.title}</h3>
              <p className="text-gray-300 text-sm leading-relaxed">{item.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AboutServices;
